import { Badge, type BadgeProps, cn } from '@sr/ui-library';

/**
 * Small count pill shared by the sidebar nav, the Tasks tab bar,
 * `AppFilterField` and `EntityList.Count` (the Home and Title Summary section
 * counts), so they all render an identical badge. Changing its size or
 * padding restyles all four. Fixed 16px height with 4px horizontal padding and
 * 12px text (Badge's default `text-xs`); `icon={null}` drops the variant's
 * default icon so only the count shows. `min-w-4` overrides Badge's wider
 * `min-w-6` so a single digit stays a 16×16 circle instead of an oval.
 * A bare number child gets thousands separators (`1,234`). Anything else
 * renders as given, including a numeric string, a template string and
 * `{count}+` (an array of children), so pass the count as a number.
 */
export const CountBadge = ({ children, className, ...props }: BadgeProps) => (
  <Badge
    className={cn('h-4 min-w-4 rounded-full px-1 font-light', className)}
    icon={null}
    {...props}
  >
    {typeof children === 'number' ? children.toLocaleString('en-AU') : children}
  </Badge>
);
